import angular from 'angular';

export default function EditWorkstationDialogController(
  $q,
  $scope,
  $rootScope,
  alerts,
  bcpDataService,
  loaderService,
  ssDialogService
) {
  const vm = this;
  vm.newWorkstation = { ...vm.workstation };

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleEditWorkstationFormSubmit = _handleEditWorkstationFormSubmit;

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.bcp.editWorkstationDialog);
  }

  function _handleCloseDialog() {
    _closeDialog();
  }

  function _handleEditWorkstationFormSubmit() {
    if ($scope.editWorkstationForm.$invalid) {
      return Promise.resolve();
    }
    const isNew = vm.newWorkstation.assessmentWorkstationId < 0;

    if (!isNew && angular.equals(vm.workstation, vm.newWorkstation)) {
      // No need to save
      return _closeDialog();
    }

    loaderService.showViewLoader = true;
    // vm.newWorkstation.assessmentId = vm.assessmentId;
    return bcpDataService.saveWorkstation(vm.assessmentId, vm.newWorkstation).then((response) => {
      const savedWorkstation = response.data;

      angular.extend(vm.newWorkstation, savedWorkstation);
      angular.extend(vm.workstation, vm.newWorkstation);

      $rootScope.$broadcast('setDocumentRegenerateFlag');
      $rootScope.$broadcast('refreshBCPWorkstations');
    
      alerts.success('The Workstation has been saved successfully.');
      
      return _closeDialog();
    })
    .catch((err) => {
      console.log(err);
      alerts.error('An error occurred while saving the Workstation.');
    })
    .finally(() => {
      loaderService.showViewLoader = false;
    });
  }
}

EditWorkstationDialogController.$inject = [
  '$q',
  '$scope',
  '$rootScope',
  'alerts',
  'bcpDataService',
  'loaderService',
  'ssDialogService'
];
